import React, { useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Brands from './components/Brands';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import { Toaster } from './components/ui/sonner';

function App() {
  useEffect(() => {
    // Notify backend of new visitor
    const trackVisitor = async () => {
      try {
        const API_URL = process.env.REACT_APP_BACKEND_URL;
        await fetch(`${API_URL}/api`, {method: 'GET'});
      } catch (error) {
        console.error('Failed to track visitor:', error);
      }
    };

    trackVisitor();
  }, []);

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <Brands />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton phoneNumber="971586712077" message="Hello, I would like to make an enquiry." />
      <Toaster />
    </div>
  );
}

export default App;